import client from '../base-api';

const serviceURL = '/meeting-room';

const meetingRoomService = {

    getMeetingRooms(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getMeetingRoom(meetingRoomId: number) {
        return client.get(`${serviceURL}/${meetingRoomId}`);
    },

    postMeetingRoom(meetingRoomData: any) {
        return client.post(`${serviceURL}`, meetingRoomData);
    },

    putMeetingRoom(meetingRoomData: any, meetingRoomId: number) {
        return client.put(`${serviceURL}/${meetingRoomId}`, meetingRoomData);
    },

    deleteMeetingRoom(meetingRoomId: number) {
        return client.delete(`${serviceURL}/delete/${meetingRoomId}`);
    },
}

export default meetingRoomService;